// Why a feedback has no screenshot, for the admin Feedback page (2026-10-20,
// feedback.screenshot_status, migration 0146). Null when there is nothing to
// say: a screenshot is there, or the row predates the status.
const TEXT = Object.freeze({
  timeout: 'No screenshot: timed out',
  error: 'No screenshot: capture failed',
  too_large: 'No screenshot: too large',
  none: 'No screenshot: none taken',
  invalid: 'No screenshot: rejected by the server',
  upload_failed: 'No screenshot: upload failed',
})

export function missingScreenshotText(status) {
  return TEXT[status] ?? null
}
